import Address, { IAddress, IAddressApiModel } from './Address.model';

export interface IManufacturerAddress {
  id: number;
  addressId: string;
  address: IAddress;
}

export interface IManufacturerAddressApiModel {
  id: number;
  addressId: string;
  address: IAddressApiModel;
}

export default class ManufacturerAddress implements IManufacturerAddress {
  public readonly id: number;

  public readonly addressId: string;

  public readonly address: IAddress;

  constructor(id: number, addressId: string, address: IAddress) {
    this.id = id;
    this.addressId = addressId;
    this.address = address;
  }

  static fromApiModel(apiModel: IManufacturerAddressApiModel) {
    const { id, addressId } = apiModel;

    const address = Address.fromApiModel(apiModel.address);

    return new ManufacturerAddress(id, addressId, address);
  }

  static arrayFromApiModel(arrayApiModel: IManufacturerAddressApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, addressId } = apiModel;

      const address = Address.fromApiModel(apiModel.address);

      return new ManufacturerAddress(id, addressId, address);
    });

    return array;
  }
}
